export default __webpack_public_path__ + "img/map-marker-adult_centers.f1f0be3c.png";